const TOKEN_KEY = 'token'
const EXPIRE_KEY = 'login_expire'
const USER_KEY = 'user_info'
const LOGIN_DURATION = 24 * 60 * 60 * 1000 // 24 小时

export function saveAuth(token, user = {}) {
  const expireAt = Date.now() + LOGIN_DURATION
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(EXPIRE_KEY, String(expireAt))
  localStorage.setItem(USER_KEY, JSON.stringify(user))
  return expireAt
}

export function getAuth() {
  const token = localStorage.getItem(TOKEN_KEY)
  const expireAt = Number(localStorage.getItem(EXPIRE_KEY))
  if (!token || !expireAt) return null
  if (Date.now() > expireAt) {
    clearAuth()
    return null
  }
  let user = { name: '', role: '商务专员' }
  try {
    user = JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  } catch (e) {
    // ignore
  }
  return { token, user, expireAt }
}

export function isLoggedIn() {
  return !!getAuth()
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(EXPIRE_KEY)
  localStorage.removeItem(USER_KEY)
}

export { TOKEN_KEY, LOGIN_DURATION }
